module.exports = __webpack_public_path__ + "static/img/3.27a9155c.jpg";